import CampaignPrizeCard from './campaignPrizeCard.container';

export default CampaignPrizeCard;